import { MDropdown } from '@Components/Base';
import { MoreOutlined } from '@ant-design/icons';
import { ReactComponent as ViewIcon } from '@Icons/additional/eye.svg';
import { ReactComponent as EditIcon } from '@Icons/additional/edit.svg';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash.svg';
import { ReactComponent as DownloadIcon } from '@Icons/additional/download.svg';
import { Flex, MenuProps } from 'antd';
import { useAppDispatch } from '@Hooks/index';
import { modalActions } from '@Store/slices/modalSlice';
import {
  ColumnMaterialDataType,
  ColumnDocumentDataType,
} from '../../../DataSource/type';

interface ActionColumnProps {
  record: ColumnMaterialDataType | ColumnDocumentDataType;
}

const ActionColumn: React.FC<ActionColumnProps> = ({ record }) => {
  const dispatch = useAppDispatch();

  const isDocument = Object.hasOwn(record, 'document');

  const recordKey = isDocument
    ? JSON.stringify((record as ColumnDocumentDataType).document)
    : String(record?.key);

  const handleDelete = (): void => {
    dispatch(
      modalActions.setStatusModal({
        key: recordKey,
        status: true,
        type: 'Delete',
      })
    );
  };

  const handleView = (): void => {
    dispatch(
      modalActions.setStatusModal({
        key: String(record?.key),
        status: true,
        type: 'View',
      })
    );
  };

  const handleEdit = (): void => {
    dispatch(
      modalActions.setStatusModal({
        key: String(record?.key),
        status: true,
        type: 'Edit',
      })
    );
  };

  const handleDownloadDocument = (): void => {
    dispatch(
      modalActions.setStatusModal({
        key: String(record?.key),
        status: true,
        type: 'Download',
      })
    );
  };

  const items = (): MenuProps['items'] => [
    {
      label: (
        <Flex gap={15} onClick={handleView}>
          <ViewIcon /> <span>View</span>
        </Flex>
      ),
      key: '0',
    },
    {
      label: (
        <Flex gap={15} onClick={handleEdit}>
          <EditIcon /> <span>Edit</span>
        </Flex>
      ),
      key: '1',
    },
    {
      label: (
        <Flex gap={15} onClick={handleDelete}>
          <DeleteIcon /> <span>Delete</span>
        </Flex>
      ),
      key: '2',
    },
    {
      label: (
        <Flex gap={15} onClick={handleDownloadDocument}>
          <DownloadIcon /> <span>Download</span>
        </Flex>
      ),
      key: '3',
    },
  ];

  return (
    <div>
      <Flex style={{ marginLeft: '15px' }}>
        <MDropdown menu={{ items: items() }} trigger={['click']}>
          <MoreOutlined />
        </MDropdown>
      </Flex>
    </div>
  );
};

export default ActionColumn;
